import { AuthContextValue } from '../state/AuthProvider';

export type PwaRouteKey =
    | 'kalender'
    | 'kalender_print'
    | 'games'
    | 'internal'
    | 'profile'
    | 'admin'
    | 'login'
    | 'register';

export type Visibility =
    | 'public'
    | 'guest'
    | 'auth'
    | 'user'
    | 'admin';

export type PwaRoute = {
  key: PwaRouteKey;
  path: string;
  label: string;
  hint: string;
  visibility: Visibility;
};

export const pwaRoutes: PwaRoute[] = [
  {
    key: 'kalender',
    path: '/kalender/',
    label: 'Kalender',
    hint: 'Termine',
    visibility: 'public',
  },
  {
    key: 'kalender_print',
    path: '/kalender/druck/',
    label: 'Druckansicht',
    hint: 'Halbjahreskalender',
    visibility: 'auth',
  },
  {
    key: 'games',
    path: '/spiele/',
    label: 'Spiele',
    hint: 'Mini-Games',
    visibility: 'public',
  },
  {
    key: 'internal',
    path: '/intern/',
    label: 'Intern',
    hint: 'Mitgliederbereich',
    visibility: 'auth',
  },
  {
    key: 'profile',
    path: '/profil/',
    label: 'Profil',
    hint: 'Benutzer & Kinder',
    visibility: 'user',
  },
  {
    key: 'admin',
    path: '/admin/',
    label: 'Admin',
    hint: 'Verwaltung',
    visibility: 'admin',
  },
  {
    key: 'login',
    path: '/login/',
    label: 'Login',
    hint: 'Anmelden',
    visibility: 'guest',
  },
  {
    key: 'register',
    path: '/registrieren/',
    label: 'Registrieren',
    hint: 'Konto beantragen',
    visibility: 'guest',
  },
];

function normalizePath(pathname: string): string {
  if (!pathname.startsWith('/')) {
    pathname = `/${pathname}`;
  }

  if (!pathname.endsWith('/')) {
    pathname = `${pathname}/`;
  }

  return pathname;
}

export function getCurrentRoute(
    pathname = window.location.pathname,
): PwaRoute {
  const normalizedPath = normalizePath(pathname);

  const matchingRoutes = pwaRoutes
      .filter((route) => normalizedPath.startsWith(route.path))
      .sort((a, b) => b.path.length - a.path.length);

  return matchingRoutes[0] ?? pwaRoutes[0];
}

export function canAccessRoute(
    route: PwaRoute,
    authContext: AuthContextValue,
): boolean {
  if (route.visibility === 'public') {
    return true;
  }

  if (route.visibility === 'guest') {
    return !authContext.auth.authenticated;
  }

  if (route.visibility === 'auth') {
    return authContext.canViewInternal;
  }

  if (route.visibility === 'user') {
    return authContext.canViewUserArea;
  }

  if (route.visibility === 'admin') {
    return authContext.canViewAdmin;
  }

  return false;
}

export function getVisibleRoutes(
    authContext: AuthContextValue,
): PwaRoute[] {
  return pwaRoutes.filter((route) => canAccessRoute(route, authContext));
}